import { useEffect } from 'react';
import { useApi } from './useApi';
import type { SubscriptionPlan } from '../types';

/**
 * Hook to fetch available subscription plans
 */
export function usePlans() {
  const { data, loading, error, fetchData } = useApi<SubscriptionPlan[]>(
    '/api/billing/plans'
  );

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { plans: data, loading, error, refetch: fetchData };
}
